import { useServices } from "@hq/client-react";
import type { Project } from "@hq/contracts";
import { RenameInput } from "@z/ui";
import { useRef, useState } from "react";

export function ProjectTitle({ project }: { project: Project }) {
  const services = useServices();
  const [editing, setEditing] = useState(false);
  const titleRef = useRef<HTMLButtonElement>(null);

  return editing ? (
    <RenameInput
      initial={project.name}
      label="Project name"
      className="h-8 w-64 max-w-full px-1 text-[18px] font-semibold tracking-tight"
      onSave={(name) => services.projects.rename(project.id, name)}
      onClose={() => {
        setEditing(false);
        requestAnimationFrame(() => titleRef.current?.focus());
      }}
    />
  ) : (
    <button
      ref={titleRef}
      type="button"
      aria-label={`Rename project ${project.name}`}
      title="Double-click to rename"
      className="min-w-0 cursor-text rounded-sm text-left [overflow-wrap:anywhere] focus-ring"
      onDoubleClick={() => setEditing(true)}
      onClick={(event) => {
        if (event.detail === 0) setEditing(true);
      }}
      onKeyDown={(event) => {
        if (event.key === "F2") {
          event.preventDefault();
          setEditing(true);
        }
      }}
    >
      {project.name}
    </button>
  );
}
